import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../pages/Login";
import Register from "../pages/Register";
import Code from "../pages/Code";
import ResetPassword from "../pages/ResetPassword";

function AuthRoutes() {
  return (
    <Routes>
      {/* for desktop app */}
      {/* <Route path="" element={<Login />} /> */}

      {/* for web browser */}
      <Route path="" element={<Login />} />
      <Route path="login" element={<Login />} />
      <Route path="register" element={<Register />} />
      <Route path="code" element={<Code />} />
      <Route path="reset-password/:token" element={<ResetPassword />} />
    </Routes>
  );
}

export default AuthRoutes;
